import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SmartyStreetsFloatingField from 'components/essentials/SmartyStreetsFloatingField';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import TwoColumnFormFields from 'components/consumer/TwoColumnFormFields';
import ZipField from '../../../Shipping/components/ZipField';
import CityField from '../../../Shipping/components/CityField';
import StateField from '../../../Shipping/components/StateField';
import ApartmentField from '../../../Shipping/components/ApartmentField';
import PhoneNumberField from '../../../Shipping/components/PhoneNumberField';

const BillingAddressFields = ({
  apartmentFieldPlaceholder,
  errors,
  handleBlur,
  handleChange,
  id,
  isRequired,
  setFieldTouched,
  setFieldValue,
  touched,
  values,
  variant,
}) => {
  const addressRef = useRef();
  return (
    <div
      className={classNames(
        'billing-address-section [border-top:1px_solid_#e5e5e5] mt-8 pt-8',
        {
          'mt-4 pt-4': variant === 'ConvertToOrderModalUI',
        }
      )}
    >
      <SmartyStreetsFloatingField
        showError
        id={`${id}.address`}
        refField={addressRef}
        name={`${id}.address`}
        error={errors.address}
        value={values.address}
        isRequired={isRequired}
        handleBlur={handleBlur}
        handleChange={handleChange}
        isTouched={touched.address}
        setFieldValue={setFieldValue}
        stateFieldName={`${id}.state`}
        cityFieldName={`${id}.city`}
        zipCodeFieldName={`${id}.zipcode`}
        addressFieldName={`${id}.address`}
      />

      <CityField
        id={`${id}.city`}
        name={`${id}.city`}
        value={values.city}
        error={errors.city}
        isTouched={touched.city}
        handleBlur={handleBlur}
        handleChange={handleChange}
        isRequired={isRequired}
      />

      <TwoColumnFormFields>
        <ApartmentField
          id={`${id}.apartment`}
          name={`${id}.apartment`}
          value={values.apartment}
          error={errors.apartment}
          handleBlur={handleBlur}
          handleChange={handleChange}
          isTouched={touched.apartment}
          placeholder={apartmentFieldPlaceholder}
        />

        <LabeledTextInput
          id={`${id}.company`}
          type="text"
          name={`${id}.company`}
          label="Company (optional)"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.company}
          autoComplete="organization"
          data-xc="shipping-company-field"
        />
      </TwoColumnFormFields>

      <TwoColumnFormFields>
        <StateField
          id={`${id}.state`}
          name={`${id}.state`}
          value={values.state}
          error={errors.state}
          handleBlur={handleBlur}
          isTouched={touched.state}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          isRequired={isRequired}
        />

        <ZipField
          id={`${id}.zipcode`}
          name={`${id}.zipcode`}
          value={values.zipcode}
          error={errors.zipcode}
          handleBlur={handleBlur}
          isTouched={touched.zipcode}
          handleChange={handleChange}
          isRequired={isRequired}
        />
      </TwoColumnFormFields>

      <PhoneNumberField
        id={`${id}.phone_number`}
        name={`${id}.phone_number`}
        placeholder="Phone"
        handleBlur={handleBlur}
        handleChange={handleChange}
        error={errors.phone_number}
        value={values.phone_number}
        isTouched={touched.phone_number}
        isRequired={isRequired}
      />
    </div>
  );
};

BillingAddressFields.propTypes = {
  apartmentFieldPlaceholder: PropTypes.string,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  values: PropTypes.object,
  variant: PropTypes.oneOf(['ConvertToOrderModalUI']),
};

export default BillingAddressFields;
